// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1JLwy","selects":"Documents_selects__3KeQS"};